import React from 'react';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import Load from 'components/Load';
import basePath from 'utils/basePath';

const AsyncOverviewPage = Load(() => import(/* webpackChunkName: "overview-page" */'./OverviewPage'), {}, true);

const OverviewPageRoutes = (
  <NavigationableLayout
    key="overviewPage"
    path={`${basePath}/overview/:country?/:city?`}
    component={AsyncOverviewPage}
    showSearchInNavbar
    showBottomNavigation
  />
);

export default OverviewPageRoutes;
